// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://mwdyfuijinjyomdeutbe.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im13ZHlmdWlqaW5qeW9tZGV1dGJlIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDMxOTQyODAsImV4cCI6MjA1ODc3MDI4MH0.XmicgdwdB68N-2jun4Snt7WsWl3wsbnH0VDXW6TgN6M";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);